export default __webpack_public_path__ + "static/media/logo-link4pay.7caace6e.png";